export default __webpack_public_path__ + "static/media/C270253.bdb608c7.jpg";